export default __webpack_public_path__ + "static/media/hourglass.cc743080.svg";